import Vue from 'vue'
import storage from "@/core/utils/storage";

// 基础配置对象（统一管理）
const baseConfig = {
    // 开发环境基础地址（只需修改这里）
    // devBase: 'http://192.168.1.67',
    // devBase: 'https://openapi.starguar.net',
    // devBase: 'http://10.10.12.72',
    // devBase: 'http://192.168.31.22',
    // 本机联调：走相对路径，由 webpack devServer.proxy 反代到本机后端
    devBase: '',

    // 生产环境自动获取当前地址
    prodBase: document.location.protocol + "//" + document.location.host,

    // 默认图片路径配置化
    defaultImage: './static/head.jpg',

    // 环境标识
    env: process.env.NODE_ENV
}

// 生成完整URL对象的工厂函数
const createUrlObject = (base) => ({
    httpUrl: base,
    imUrl: base,
    fileUrl: base
})

// 环境配置
const envUrls = {
    production: createUrlObject(baseConfig.prodBase),
    development: createUrlObject(baseConfig.devBase)
}

// 当前环境配置
const currentEnv = envUrls[baseConfig.env]

// URL拼接工具函数
const buildUrl = (base, suffix) => {
    if (!suffix) return base
    return `${base}${suffix}`
}

// WebSocket协议转换函数
const getWebSocketUrl = (httpUrl) => {
    // 处理HTTPS协议情况
    return httpUrl.replace('http', 'ws')
}

const Config = {
    pc_version: '213', // 管理端版本号
    suffix_http_url: '/api/main',
    suffix_im_url: '/api/im',
    suffix_img_url: '/api/file',
    default_image: baseConfig.defaultImage,
    getUserType() {
        return storage.get('userData').userType
    },
    isManager() {
        const userType = storage.get('userData').userType

        return userType === 'system' || userType === 'company'
    },
    getPCVersion() {
        return this.pc_version
    },

    getBaseUrl() {
        return buildUrl(currentEnv.httpUrl, this.suffix_http_url)
    },

    getIMBaseUrl() {
        return buildUrl(currentEnv.imUrl, this.suffix_im_url)
    },

    getWS() {
        const wsBase = getWebSocketUrl(currentEnv.imUrl)
        return buildUrl(wsBase, `${this.suffix_im_url}/ws/`)
    },

    getImageUrl(url) {
        if (!url) return this.default_image
        return this.getImgBase() + url
    },

    getImgBase() {
        return buildUrl(currentEnv.fileUrl, this.suffix_img_url)
    },

    isProduction() {
        return baseConfig.env === 'production'
    },

    isDevelopment() {
        return baseConfig.env === 'development'
    },

    getHost() {
        return document.location.host
    },

    setLeftWidth(width) {
        document.documentElement.style.setProperty('--width-primary', width)
    }
}

Vue.prototype.$Config = Config
export default Config